module.exports = __webpack_public_path__ + "img/smart_appearance4.955ac924.png";